<script>
    export default {
        data() {
            return {
                isShowSidebar: false,
                title: 'Formulir'
            }
        },
        mounted: function () {
            this.init();
        },
        watch: {
            'isShow': function () {
                this.init();
            }
        },
        computed: {
            sidebarComponent: function () {
                return this.$store.state.sidebar.sidebarComponent;
            },
            sidebarParams: function () {
                return this.$store.state.sidebar.sidebarParams;
            },
            isShow: function () {
                return this.$store.state.sidebar.sidebarShow;
            }
        },
        methods: {
            init: function () {
                if (this.isShow) {
                    this.isShowSidebar = true;
                } else {
                    this.isShowSidebar = false;
                }
            },
        }
    }
</script>

<template>
    <BOffcanvas class="border-0" id="theme-settings-offcanvas" header-class="d-flex align-items-center bg-primary p-3"
        body-class="p-0" footer-class="border-top p-3 text-center" placement="end" v-model="isShowSidebar"
        @hidden="$sidebar.hide()">
        <component class="sidebar-content" v-if="isShowSidebar" v-bind:is="sidebarComponent" v-bind="sidebarParams">
        </component>
        <template #header>
            <div class="me-2">
                <h5 class="m-0 me-2 text-white">{{ title }}</h5>
            </div>
            <button type="button" class="btn-close btn-close-white ms-auto" id="customizerclose-btn"
                @click="$sidebar.hide()"></button>
        </template>
    </BOffcanvas>
</template>